// Per-browser "Recently Viewed" Global Search entries - records records the
// user actually opened by clicking through a search RESULT ROW (employees,
// leaveRequests, attendanceRecords, holidays, policies - the same categories
// handleSelect in index.js handles), as distinct from recentSearchStore.js's
// "Recent" (recent searches/selections of every kind, including quick links
// and actions). Local only, no backend - same storage convention as
// recentSearchStore.js but under its OWN key so the two lists never mix.
//
// Scoped per company + user (companyDomain slug + logged-in user's _id) so a
// shared/public browser doesn't leak one person's Recently Viewed to whoever
// logs in next on the same machine - and so switching accounts in the same
// browser never shows the previous user's list.
import { getGlobalSearchKeySuffix } from "./globalSearchStorageKey";

const MAX_RECENTLY_VIEWED = 8;

const getStorageKey = () => `globalSearch.recentlyViewed.${getGlobalSearchKeySuffix()}`;

export const getRecentlyViewed = () => {
  try {
    const raw = localStorage.getItem(getStorageKey());
    const parsed = raw ? JSON.parse(raw) : [];
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

// `entry` is the minimal {id, label, subtitle, route, iconCategory, categoryKey}
// shape the caller builds - `id` is used only for de-duplication (re-opening
// the same record moves it to the top instead of adding a duplicate row).
export const addRecentlyViewed = (entry) => {
  if (!entry?.id) return;
  try {
    const existing = getRecentlyViewed().filter((item) => item.id !== entry.id);
    const next = [{ ...entry, viewedAt: Date.now() }, ...existing].slice(0, MAX_RECENTLY_VIEWED);
    localStorage.setItem(getStorageKey(), JSON.stringify(next));
  } catch (e) {
    // Private browsing / storage blocked - fail soft, Recently Viewed is a nice-to-have.
  }
};

export const clearRecentlyViewed = () => {
  try {
    localStorage.removeItem(getStorageKey());
  } catch (e) {
    // Private browsing / storage blocked - nothing to clear anyway.
  }
};
